<template>
  <v-footer
    v-if="displayFooter"
    height="auto"
    class="text-white text-center"
    :style="appColor"
  >
    <v-row justify="center">
      <!--<v-btn
        v-for="link in links"
        :key="link"
        color="white"
        flat
      >
        {{ link }}
      </v-btn>-->
      <v-col
        cols="12"
        class="py-3 text-center text-white"
      >
        &copy;2018 — <strong>Slick Cactus</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: ['Home', 'About Us', 'Team', 'Services', 'Blog', 'Contact Us'],
    displayFooter: false,
  }),
  computed: {
    appColor () {
      return 'background: ' + this.$store.state.color
    },
  },
}
</script>
